// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import {
    Divider,
    FormControl,
    IconButton,
    TextField,
    Tooltip,
    Typography,
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';
import { useToast } from '../../../components/ToastProvider';
import moment from 'moment';
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Swal from 'sweetalert2'
export default function Index() {
    const { showToast, hideToast } = useToast();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const navigate = useNavigate();
    const [listData, setListData] = useState<any[]>([])

    const [openHistory, setOpenHistory] = useState(false)
    const [openForm, setOpenForm] = useState(false)

    const [listHistory, setListHistory] = useState<any[]>([])
    const [loadingHistory, setLoadingHistory] = useState(false)
    const [perTgl, setPerTgl] = useState<string>(
        moment().format('YYYY-MM-DD')
    )
    const today = new Date().toISOString().split('T')[0]

    const [form, setForm] = useState({
        mmbarang_id: '',
        tgl_aktif: today,
        harga: '',
        harga_coret: '',
        harga_bawah: ''
    })

    const [errors, setErrors] = useState<any>({})

    const validateForm = () => {
        const newErrors: any = {}

        if (!form.tgl_aktif) newErrors.tgl_aktif = 'Tanggal aktif wajib diisi'
        if (!form.harga) newErrors.harga = 'Harga wajib diisi'
        if (!form.harga_coret) newErrors.harga_coret = 'Harga coret wajib diisi'
        if (!form.harga_bawah) newErrors.harga_bawah = 'Harga bawah wajib diisi'

        setErrors(newErrors)

        return Object.keys(newErrors).length === 0
    }

    const handleOpenHistory = async (row: any) => {
        try {
            setOpenHistory(true)
            setLoadingHistory(true)

            const res = await axios.get(
                apiUrl.apiUrl + '/omni/product-price/history',
                {
                    params: {
                        mmbarang_id: row.id
                    },
                    headers: { Authorization: `Bearer ${token}` }
                }
            )

            setListHistory(res.data.data || [])
        } catch (err) {
            console.error(err)
        } finally {
            setLoadingHistory(false)
        }
    }

    const handleOpenForm = (row: any) => {
        setErrors({})

        setForm({
            mmbarang_id: row.id,
            tgl_aktif: new Date().toISOString().split('T')[0],
            harga: row.harga || '',
            harga_coret: row.harga_coret || '',
            harga_bawah: row.harga_bawah || ''
        })

        setOpenForm(true)
    }

    const handleSave = async () => {
        if (!validateForm()) return

        try {
            await axios.post(
                apiUrl.apiUrl + '/omni/product-price/save',
                form,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            )

            setListData((prev: any[]) =>
                prev.map((item) => {
                    if (item.id === form.mmbarang_id) {
                        return {
                            ...item,
                            harga: form.harga,
                            harga_coret: form.harga_coret,
                            harga_bawah: form.harga_bawah,
                            per_tgl: form.tgl_aktif
                        }
                    }

                    return item
                })
            )
            showToast('Berhasil simpan harga',"success")

            setOpenForm(false)
        } catch (err: any) {
            showToast(err?.response?.data?.message || 'Gagal simpan',"error")
        }
    }

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 120,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Tooltip title={"Lihat History"} placement="top">
                        <IconButton
                            onClick={() => handleOpenHistory(row)}
                        >
                            <Icon icon={"mdi:history"} />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title={"Rubah Harga"} placement="top">
                        <IconButton
                            onClick={() => handleOpenForm(row)}
                        >
                            <Icon icon={"mdi:pencil"} />
                        </IconButton>
                    </Tooltip>
                </Box>
            ),
        },
    ]

    useEffect(() => {
        getData()
    }, [])
    const getData = () => {
        setListData([])
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/omni/product-price/list'

        axios
            .get(url, {
                params: {
                    per_tgl:perTgl
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const convertComponent = [
        {
            key: 'nama_barang',
            minWidth: 200,
            maxWidth: 200,
            renderCell: ({ row }: any) => {
                return (
                    <Box sx={{ maxWidth: 200, whiteSpace: 'normal', wordWrap: 'break-word' }}>
                        {row.data?.nama_barang}
                    </Box>
                );
            }
        },
        {
            key: 'link',
            renderCell: ({ row }: any) => {
                const url = row.data?.link;

                if (!url) {
                    return <span style={{ color: "#999" }}>Tidak ada gambar</span>;
                }

                const openImage = () => {
                    Swal.fire({
                        title: 'Preview Gambar',
                        imageUrl: url,
                        imageWidth: 400,     // atur ukuran gambar
                        imageHeight: 'auto',
                        imageAlt: 'Preview',
                        showCloseButton: true,
                        showConfirmButton: false,
                        background: '#f9f9f9',
                    });
                };

                return (
                    <img
                        src={url}
                        alt="Preview"
                        style={{
                            height: "120px",
                            width: "auto",
                            objectFit: "contain",
                            borderRadius: "8px",
                            cursor: "pointer",
                        }}
                        onClick={openImage}
                    />
                );
            }
        }
    ];
    
    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                            px: 2,
                            py: 1
                        }}
                    >
                        {/* Title Section */}
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                HARGA PRODUCT
                            </Typography>
                        </Box>

                        {/* Button Section */}
                        <Box>
                            <Button
                                variant="contained"
                                color="warning"
                                startIcon={<Icon icon="mdi:arrow-left" />}
                                onClick={() => navigate(-1)}
                            >
                                Kembali
                            </Button>
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start',mb:3 }}
                            spacing={5}
                        >
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>

                                    <TextField
                                        label='Per Tanggal'
                                        type='date'
                                        onChange={(e) => setPerTgl(e.target.value)}
                                        value={perTgl}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={() => getData()}
                                    >
                                        Cari Data
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <MsiDatagrid array={listData} customRender={convertComponent} actions={actionData} convertRupiah={['harga','harga_coret','harga_bawah']} />
                    </CardContent>
                </div>
            </Grid>
            <Dialog
                open={openHistory}
                onClose={() => setOpenHistory(false)}
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle>
                    History Harga
                </DialogTitle>
                <DialogContent>
                    <MsiDatagrid
                        array={listHistory}
                        convertRupiah={['harga','harga_coret','harga_bawah']}
                    />
                </DialogContent>
            </Dialog>
            <Dialog
                open={openForm}
                onClose={() => setOpenForm(false)}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>
                    Rubah Harga
                </DialogTitle>

                <DialogContent>
                    <Grid container spacing={3} sx={{ mt: 1 }}>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                type="date"
                                label="Tanggal Aktif"
                                InputLabelProps={{ shrink: true }}
                                value={form.tgl_aktif}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        tgl_aktif: e.target.value
                                    })
                                }
                                error={!!errors.tgl_aktif}
                                helperText={errors.tgl_aktif}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Harga"
                                value={form.harga}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        harga: e.target.value
                                    })
                                }
                                error={!!errors.harga}
                                helperText={errors.harga}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Harga Coret"
                                value={form.harga_coret}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        harga_coret: e.target.value
                                    })
                                }
                                error={!!errors.harga_coret}
                                helperText={errors.harga_coret}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Harga Bawah"
                                value={form.harga_bawah}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        harga_bawah: e.target.value
                                    })
                                }
                                error={!!errors.harga_bawah}
                                helperText={errors.harga_bawah}
                            />
                        </Grid>

                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: '#9e9e9e',
                            '&:hover': {
                                backgroundColor: '#757575'
                            }
                        }}
                        onClick={() => setOpenForm(false)}
                    >
                        Batal
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSave}
                    >
                        Simpan
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}